export default __webpack_public_path__ + "static/media/photo-02.1961dc59.jpg";